import { CalculatorView } from "./calculator.view";
import { DrawerView } from "./drawer.view";
import { BackgroundView } from "./background.view";

export const calculator = new CalculatorView();
export const drawer = new DrawerView();
export const background = new BackgroundView();
